import React from 'react';
import styles from './index.module.scss';

const ProgressDots = ({ count, activeIndex, className }) => {
  if (count <= 1) return null;

  return (
    <div aria-hidden="true" className={`${styles.progressDots} ${className || ''}`}>
      {Array.from({ length: count }, (_, i) => (
        <span
          key={i}
          className={`${styles.dot} ${i === activeIndex ? styles['dot--active'] : ''}`}
        />
      ))}
    </div>
  );
};

export default ProgressDots;
